module.exports = __webpack_public_path__ + "img/health.e1bd5bb0.png";